// @ts-check
import React from "react";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { useFeatureFlag } from "src/contexts/global/FeatureFlagsContext";
import { useAISidebar } from "src/hooks/useAISidebar";
import { AIChatWindow, AIChatWindowWithAgentCore } from "../AIContent";

export const AINav = () => {
  const { enableAIChat } = useWorkspaceFeatureFlags();
  const enableAgentCore = useFeatureFlag("enable-agentcore");

  const { isOpen } = useAISidebar();

  if (!enableAIChat) {
    return null;
  }

  if (enableAgentCore) {
    return (
      <div style={{ display: isOpen ? "block" : "none" }}>
        <AIChatWindowWithAgentCore />
      </div>
    );
  }

  // Always render the component but conditionally show content
  return isOpen && <AIChatWindow />;
};
